import EventBackground from './EventBackground';

export default EventBackground;
